import Marquee from "react-fast-marquee";

const items = [
  "Té Divina", "Salud y Bienestar", "Control de Peso", "Energía Natural",
  "Ganoderma Reishi", "100% Natural", "Café Funcional", "Colágeno",
];

export const EditorialMarquee = () => (
  <div className="bg-forest-900 py-6 md:py-8 border-y border-sand/10" data-testid="marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-8 md:mx-14 font-serif italic text-3xl md:text-5xl text-sand/40 flex items-center gap-8 md:gap-14">
          {t}
          <span className="text-terracotta-500 text-2xl not-italic">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
